
import wx from 'weixin-js-sdk'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
name: 'curtainAddGoods',
components: {
wx,PopupPicker,CheckIcon,XTextarea,Group
},
data() {
return {
pop:false,
filePath: [],
formData:{
id:0,
title:'',
service_hours:'',
status:1,
content:''
},
}
},
created() {
this.formData.id = Number(this.$route.params.id);
if(this.formData.id > 0){
this.getCurtainGoods();
}
this.config();
},
computed:{

},
methods: {
getCurtainGoods() {
this.$api.getCurtainGoods({id:this.formData.id}).then((res)=>{
if(res){
this.formData = res.data;
}
})
},
submit() {
if(!this.formData.title){
this.$func.showToast('请输入产品名称');
return false;
}
this.$api.submitCurtainGoods(this.formData).then((res)=>{
this.$func.showToast('提交成功');
setTimeout(()=>{
this.$router.go(-1);
},300)
});
},
config(){








let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false, //调试阶段建议开启
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"chooseImage",
"uploadImage",
]
});
}
})
},
uploadFile(){
let that = this;
wx.chooseImage({
count: 9,
sizeType: ['original', 'compressed'],
sourceType: ['album', 'camera'],
success: function (res) {
that.uploadImg(res.localIds);
}
});
},
uploadImg(localIds){
let localId = localIds.pop();
let that = this;
wx.uploadImage({
localId: localId,
success: function (res) {
that.$api.uploadsImg({serverId:res.serverId,path:'product'}).then((res)=>{
if(res){
that.filePath.push(res.data.url);
that.formData.pics.push(res.data.path);
if(localIds.length > 0){
that.uploadImg(localIds);
}
}
})
}
});
},
showPic(index) {
wx.previewImage({
current: this.filePath[index], // 当前显示图片的http链接
urls: this.filePath 
});
},
delImg(index){
this.filePath.splice(index,1);
this.formData.pics.splice(index,1);
}
}
}



// WEBPACK FOOTER //
// ./src/pages/curtainAddGoods.vue